import { Text } from '@main/complykit/components/text';

import { parseMarkdownInline } from './markdown-inline';

export type MarkdownTextProps = {
  text: string;
};

/** Each line its own paragraph, for a Callout or a card body; a field's description takes MarkdownInline. */
export const MarkdownText = ({ text }: MarkdownTextProps) =>
  text.split('\n').map((line, index) => <Text key={index}>{parseMarkdownInline(line)}</Text>);
